import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Yii } from "../../../libraries/interfaces/Yii";
import { EAirSearchContext } from '../air-search.component';

export class Wording {
    public readonly airSearchHeaderTitleForm: string = Yii.t('wui-iqba-js', 'Recherche d\'itinéraire');
    public readonly airSearchHeaderTitleResume: string = Yii.t('wui-iqba-js', 'Résumé de la recherche');
}

@Component({
    selector: 'air-search-header',
    templateUrl: './air-search-header.component.html',
    styleUrls: ['./air-search-header.component.scss']
})
export class AirSearchHeaderComponent {
    @Input()
    public hasAirSearchRequest: boolean;
    @Input()
    public canUseAirSearchForm: boolean = false;
    @Input()
    public isAirSearchFormVisible: boolean;
    @Input()
    public airSearchContext: EAirSearchContext = null;
    public readonly wording: Wording = new Wording();
}
